import { PmiButton } from 'shell/components/shared/button';
import { useCallback, ReactElement, useMemo, memo } from 'react';
import { Command, Key as KeyType } from './types';

interface KeyComponentProps extends KeyType {
  handleChange: (key: KeyType) => void;
  uppercaseActive: boolean;
}

const KeyComponent = (key: KeyComponentProps): ReactElement => {
  const isShiftCommand = key.command === Command.Uppercase;

  const textTransform = useMemo(() => {
    const isCommand = !!key.command;

    const commandCase = isCommand ? 'unset' : '';

    const wordCase = key.uppercaseActive ? 'uppercase' : 'unset';

    return commandCase || wordCase;
  }, [key.uppercaseActive, key.command]);

  const onClick = useCallback(() => key.handleChange(key), [key.handleChange, key]);

  return (
    <PmiButton
      type="button"
      key={key.value}
      variant="contained"
      color={isShiftCommand && key.uppercaseActive ? 'cdmBrandSecondary' : 'primary'}
      style={{
        minWidth: 'unset',
        width: key.width || '2.5rem',
        margin: '0.25rem',
        border: 'none',
        textTransform,
      }}
      onClick={onClick}
    >
      {key.value}
    </PmiButton>
  );
};

KeyComponent.displayName = 'Key component';

const Key = memo(KeyComponent);

export default Key as typeof KeyComponent;
